import React, {useState} from "react";
import DirectionsCar from '@mui/icons-material/DirectionsCar';
//import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
//import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';
//import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
//import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
//import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import HeadsetRoundedIcon from '@mui/icons-material/HeadsetRounded';
import styled from "@emotion/styled";
import SidebarIcon from "./SidebarIcon";

const Sidebar = () => {
    const routes = [
        { label: "Erprobung", path: "/", icon: <DirectionsCar fontSize="medium"/>},
      /*
        { label: "Stückliste", path: "/parts", icon: <FormatListBulletedIcon fontSize="medium"/>},
        { label: "Aufträge", path: "/tasks", icon: <WindowOutlinedIcon fontSize="medium"/>},
        { label: "Planung", path: "/plans", icon: <CalendarMonthOutlinedIcon fontSize="medium"/>},
        { label: "Protokoll", path: "/protocol", icon: <EditNoteRoundedIcon fontSize="medium"/>},
        { label: "Auswertung", path: "/evaluation", icon: <ChecklistRoundedIcon fontSize="medium"/>},
      */
    ];

    const [showFullSideBar, setShowFullSideBar] = useState(false);

    return (
        <Wrapper>
            <IconsWrapper>
                {
                    routes.map(route => (
                        <SidebarIcon
                            full={showFullSideBar}
                            label={route.label}
                            icon={route.icon}
                            path={route.path}
                            key={route.path}
                        />
                    ))
                }
            </IconsWrapper>
            <IconsWrapper>
                <SidebarIcon
                    full={showFullSideBar}
                    label={'Support'}
                    icon={<HeadsetRoundedIcon fontSize="medium" />}
                    path={'/support'}
                />
                <AddIconWrapper>
                    <AddRoundedIcon fontSize="medium" />
                </AddIconWrapper>
                <OpenIconWrapper onClick={() => setShowFullSideBar(!showFullSideBar)}>
                    {
                        showFullSideBar && <KeyboardArrowLeftRoundedIcon fontSize="medium" />
                    }
                    {
                        !showFullSideBar && <KeyboardArrowRightRoundedIcon fontSize="medium" />
                    }
                </OpenIconWrapper>
            </IconsWrapper>
        </Wrapper>
    );
}

const Wrapper = styled.div`
  height: 100%;
  width: auto;
  overflow: auto;
  background: #E9EDF3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;


const IconsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  padding: 10px 0;
`;


const OpenIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 50%;
  margin: 8px 15px;
  width: 36px;
  height: 36px;
  cursor: pointer;
`;

const AddIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background: #9598A8;
  margin: 8px 15px;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  cursor: pointer;
`;

export default Sidebar;